import React, { useCallback, useState } from 'react'
import { Alert } from 'react-bootstrap'
import Progress from '../Form/Progress'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useLocalReceiptsState } from '../../../stores/LocalReceiptsProvider'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`

const CreateReceiptSidebar = () => {
  const {
    submitAddReceipt,
    errorsOccurredOnSubmit,
    setSuccessSubmit,
    successSubmit
  } = useLocalReceiptDataState()
  const { setFilterReceipt } = useLocalReceiptsState()
  const [isSaving, setIsSaving] = useState(false)
  const navigate = useNavigate();

  const handleSubmitClick = useCallback(async e => {
    e.preventDefault()
    e.stopPropagation()
    setSuccessSubmit(false)
    setIsSaving(true)
    const createdReceiptInfo = await submitAddReceipt()
    if (createdReceiptInfo) {
    const { receiptName } = createdReceiptInfo
    setFilterReceipt(receiptName)
    setTimeout(() => {
        navigate("/localstorage/goodsreceipts")
    }, 1500)
    }
    setIsSaving(false)
  }, [setSuccessSubmit, submitAddReceipt, setFilterReceipt, navigate])

  const { t } = useTranslation()

  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('goodsReceiptOverlayProgress:headerCreate')}</div>
      </header>
      <div className="content">
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isSaving}
          onClick={handleSubmitClick}
          disabled={isSaving || successSubmit}
          buttonText={t('goodsReceiptOverlayProgress:save')}
          loadingText={t('goodsReceiptOverlayProgress:save')}
        />
        {(!!errorsOccurredOnSubmit) && (
          <Alert variant="danger">
            {t('goodsReceiptOverlayProgress:danger')}
          </Alert>
        )}
        {!!successSubmit && (
          <Alert variant="success">
            {t('goodsReceiptOverlayProgress:success')}

          </Alert>
        )}
        <Progress />
      </div>

    </StyledContainer>
  )
}

export default CreateReceiptSidebar
